import {FC, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'

const ORDERS = [
  {id:1,  buyer:'Savannah Nguyen',   event:'Beats & Brews Festival', tickets:2, price:'$25',  total:'$50',   date:'Jun 22, 2026', payment:'card',   status:'confirmed'},
  {id:2,  buyer:'Arlene McCoy',      event:'Beats & Brews Festival', tickets:4, price:'$25',  total:'$100',  date:'Jun 22, 2026', payment:'apple',  status:'confirmed'},
  {id:3,  buyer:'Robert Fox',        event:'Acoustic Nights Live',   tickets:2, price:'$29',  total:'$58',   date:'May 20, 2026', payment:'card',   status:'confirmed'},
  {id:4,  buyer:'Jenny Wilson',      event:'Acoustic Nights Live',   tickets:1, price:'$29',  total:'$29',   date:'May 20, 2026', payment:'google', status:'confirmed'},
  {id:5,  buyer:'Brooklyn Simmons',  event:'Urban Beats Showcase',   tickets:2, price:'$22',  total:'$44',   date:'May 25, 2026', payment:'card',   status:'confirmed'},
  {id:6,  buyer:'Cameron Williamson',event:'Neon Vibes Festival',    tickets:3, price:'Free', total:'$0',    date:'May 12, 2026', payment:'free',   status:'completed'},
  {id:7,  buyer:'Dianne Russell',    event:'City Jazz Night',        tickets:2, price:'Free', total:'$0',    date:'May 5, 2026',  payment:'free',   status:'completed'},
  {id:8,  buyer:'Savannah Nguyen',   event:'Soul & Strings Night',   tickets:1, price:'$35',  total:'$35',   date:'Apr 18, 2026', payment:'card',   status:'completed'},
  {id:9,  buyer:'Robert Fox',        event:'Tech Startup Mixer',     tickets:1, price:'$30',  total:'$30',   date:'Jun 10, 2026', payment:'card',   status:'confirmed'},
  {id:10, buyer:'Jenny Wilson',      event:'Rooftop Sunset Sessions',tickets:2, price:'$30',  total:'$60',   date:'Jun 5, 2026',  payment:'apple',  status:'confirmed'},
  {id:11, buyer:'Arlene McCoy',      event:'Art & Wine Evening',     tickets:2, price:'$30',  total:'$60',   date:'May 28, 2026', payment:'google', status:'completed'},
  {id:12, buyer:'Brooklyn Simmons',  event:'Soul & Strings Night',   tickets:4, price:'$35',  total:'$140',  date:'Apr 18, 2026', payment:'card',   status:'completed'},
  {id:13, buyer:'Dianne Russell',    event:'Beats & Brews Festival', tickets:1, price:'$25',  total:'$25',   date:'Jun 22, 2026', payment:'card',   status:'confirmed'},
  {id:14, buyer:'Cameron Williamson',event:'Urban Beats Showcase',   tickets:2, price:'$22',  total:'$44',   date:'May 25, 2026', payment:'apple',  status:'pending'},
]

type OrderStatus = 'all' | 'confirmed' | 'pending' | 'completed'

const statusBadge = (s: string) => {
  const m: Record<string,string> = {confirmed:'badge-light-success', pending:'badge-light-warning', completed:'badge-light-secondary'}
  return <span className={`badge ${m[s] ?? 'badge-light'} fw-bold text-capitalize`}>{s}</span>
}

const paymentIcon = (method: string) => {
  const icons: Record<string,string> = {card:'💳', apple:'🍎', google:'🔵', free:'🎟️'}
  return <span title={method}>{icons[method] ?? '💳'}</span>
}

const OrdersPage: FC = () => {
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState<OrderStatus>('all')

  const filtered = ORDERS.filter(o => {
    const q = search.toLowerCase()
    return (
      (!q || o.buyer.toLowerCase().includes(q) || o.event.toLowerCase().includes(q)) &&
      (status === 'all' || o.status === status)
    )
  })

  const totalRevenue = ORDERS
    .filter(o => o.status !== 'pending')
    .reduce((sum, o) => sum + parseFloat(o.total.replace(/[$,]/g, '') || '0'), 0)

  return (
    <div className='card'>
      <div className='card-header border-0 pt-6'>
        <div className='card-title'>
          <div className='d-flex align-items-center position-relative my-1'>
            <i className='ki-outline ki-magnifier fs-3 position-absolute ms-5 text-gray-400'></i>
            <input
              type='text'
              className='form-control form-control-solid w-250px ps-13'
              placeholder='Search orders...'
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className='card-toolbar gap-3'>
          <select className='form-select form-select-solid w-140px' value={status} onChange={e => setStatus(e.target.value as OrderStatus)}>
            <option value='all'>All Status</option>
            <option value='confirmed'>Confirmed</option>
            <option value='pending'>Pending</option>
            <option value='completed'>Completed</option>
          </select>
        </div>
      </div>
      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
            <thead>
              <tr className='text-gray-400 fw-bold fs-7 text-uppercase border-0'>
                <th className='min-w-50px'>#</th>
                <th className='min-w-160px'>Buyer</th>
                <th className='min-w-200px'>Event</th>
                <th className='min-w-60px text-center'>Qty</th>
                <th className='min-w-80px'>Unit</th>
                <th className='min-w-80px'>Total</th>
                <th className='min-w-60px text-center'>Pay</th>
                <th className='min-w-80px'>Date</th>
                <th className='min-w-80px'>Status</th>
                <th className='min-w-60px text-end'>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(o => (
                <tr key={o.id}>
                  <td className='text-muted fw-semibold fs-7'>#{o.id}</td>
                  <td className='fw-bold text-dark'>{o.buyer}</td>
                  <td className='text-muted fw-semibold fs-7'>{o.event}</td>
                  <td className='text-center fw-bold text-dark'>{o.tickets}</td>
                  <td className='fw-semibold text-dark'>{o.price}</td>
                  <td className='fw-bold text-dark'>{o.total}</td>
                  <td className='text-center fs-5'>{paymentIcon(o.payment)}</td>
                  <td className='text-muted fw-semibold fs-7'>{o.date}</td>
                  <td>{statusBadge(o.status)}</td>
                  <td className='text-end'>
                    <button className='btn btn-sm btn-light btn-active-light-primary'>View</button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={10} className='text-center text-muted py-10'>No orders found</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div className='d-flex justify-content-between align-items-center pt-4 border-top'>
          <span className='text-muted fs-7'>Showing {filtered.length} of {ORDERS.length} orders</span>
          <div className='d-flex gap-3'>
            <span className='badge badge-light-success fw-bold'>Confirmed: {ORDERS.filter(o=>o.status==='confirmed').length}</span>
            <span className='badge badge-light-warning fw-bold'>Pending: {ORDERS.filter(o=>o.status==='pending').length}</span>
            <span className='badge badge-light-secondary fw-bold'>Completed: {ORDERS.filter(o=>o.status==='completed').length}</span>
            <span className='badge badge-light-primary fw-bold'>Revenue: ${totalRevenue.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

const OrdersPageWrapper: FC = () => (
  <>
    <PageTitle breadcrumbs={[]}>Orders</PageTitle>
    <OrdersPage />
  </>
)

export {OrdersPageWrapper}
